import sitesFormDirectiveTemplate from '../templates/sites/form.html';

const SitesFormController = function SitesFormController(
  FlashService,
  SiteService,
  $window
) {
  var vm = this;
  vm.DEVICES = ['mobile', 'desktop'];
  vm.save = save;

  function create() {
    return SiteService.create(vm.site)
      .then(function() {
        $window.location.href = `/sites`;
      })
      .catch(function(response) {
        vm.site.errors = response.data.errors;
      });
  }

  function update() {
    return SiteService.update(vm.site)
      .then(function() {
        vm.site.errors = [];
        FlashService.push('success', 'Successful update');
      })
      .catch(function(response) {
        vm.site.errors = response.data.errors;
      });
  }

  function save() {
    if (vm.site.id) {
      return update();
    } else {
      return create();
    }
  }

  return vm;
};

SitesFormController.$inject = ['FlashService', 'SiteService', '$window'];

const sitesFormDirective = () => ({
  template: sitesFormDirectiveTemplate,
  controller: SitesFormController,
  controllerAs: 'ctrl',
  bindToController: true,
  scope: {
    site: '='
  }
});

export { SitesFormController, sitesFormDirective };
